import React, { useRef, useState } from "react";
import "./firstpage.css";
import { useNavigate } from "react-router-dom";

const FirstPage = () => {
 let navigate = useNavigate();
 let heartRef = useRef();
 let [heartStyle, setHeartStyle] = useState({});
 let [counter, setCounter] = useState(0);

 const heartHandle = () => {
    navigate('/secondPage');
 };

 const moveHeart = () => {
    if (counter >= 5) {
        heartHandle();
    } else {
        const heartRect = heartRef.current.getBoundingClientRect();
        const randomLeft = Math.floor(Math.random() * (window.innerWidth - heartRect.width));
        const randomTop = Math.floor(Math.random() * (window.innerHeight - heartRect.height));
        setHeartStyle({
            left: `${randomLeft}px`,
            top: `${randomTop}px`,
            position: 'absolute'
        });
        setCounter(counter + 1);
    }
 };

 return (
    <>
      <div className="Love">
        <div 
          className="heart" 
          ref={heartRef} 
          style={heartStyle} 
          onMouseOver={moveHeart}
        >
        </div>
      </div>
    </>
 );
};

export default FirstPage;
